import { createApp } from 'vue';
import { Calendar as VCalendar, DatePicker as VDatePicker, setupCalendar } from 'v-calendar';
import 'v-calendar/dist/style.css';
import autoAnimate from '@formkit/auto-animate';
import CalendarContainer from './components/Calendar.vue';
import CalendarListing from './components/CalendarListing.vue';

const appEl = document.getElementById('app');
if (appEl) {
  const app = createApp({
    components: {
      CalendarContainer,
      CalendarListing,
    },
  });

  // v-calendar 3.x wird über sein setupCalendar-Plugin registriert und
  // stellt die beiden Components dann projekt-weit unter <VCalendar> und
  // <VDatePicker> zur Verfügung.
  app.use(setupCalendar, {});
  app.component('VCalendar', VCalendar);
  app.component('VDatePicker', VDatePicker);

  // Custom-Directive für auto-animate. Der Vue-2-Lifecycle-Hook `inserted`
  // heißt in Vue 3 `mounted`.
  app.directive('auto-animate', {
    mounted(el, binding) {
      autoAnimate(el, binding.value);
    },
  });

  app.mount(appEl);
}

document.body.addEventListener('htmx:afterSwap', (event) => {
  // Optional: nur ausführen, wenn ein bestimmtes Ziel betroffen ist
  if (event.detail.target.matches('.hotsushi-calendarize')) {
    document.body.dispatchEvent(new Event('calendarTableRefresh'));
    document.body.dispatchEvent(new Event('frontendUserTableRefresh'));
  }
});

document.body.addEventListener('htmx:responseError', function (event) {
  if (event.detail.xhr.status === 403) {
    window.location.href = 'https://www.museumpab.de/team/ehrenamt/';
  }
});
